import { AdRoutes } from "@/constants/ad-routes";

/**
 * A page rendered by AuthRouter (its own standalone <BrowserRouter>
 * mounted only while logged out - see app.tsx) - login-page.tsx,
 * accept-invite-page.tsx - sometimes needs to send the user somewhere
 * specific right after auth succeeds, instead of wherever DashboardRouter's
 * router last happened to be. But the moment applyAuthResponse flips
 * isLoggedIn, the whole app swaps to DashboardRouter - a completely
 * separate, independently-created router (its own createBrowserRouter).
 * react-router's navigate() from AuthRouter's side can't reach it, and a
 * hard `window.location` reload re-runs the whole auth bootstrap
 * (token/session rehydration) for no reason, causing a visible flash.
 *
 * Instead: stash the intended destination in this plain module-level
 * variable (not React state, so it survives the AuthRouter -> DashboardRouter
 * tree swap - both trees import the same module instance), and let
 * DashboardRouter's own Layout consume it once, right after it mounts,
 * navigating with its own (correct) router context.
 */
let pendingRedirect: AdRoutes | null = null;

export const setPendingPostAuthRedirect = (route: AdRoutes): void => {
  pendingRedirect = route;
};

export const consumePendingPostAuthRedirect = (): AdRoutes | null => {
  const route = pendingRedirect;
  pendingRedirect = null;
  return route;
};
